
export default {
  props: {
    product: {
      type: [Array, Object],
      required: true,
    },
  },
};
